webpackJsonp([35783957827783],{

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.hoistNonReactStatics = factory());
	}(this, (function () {
	    'use strict';
	    
	    var REACT_STATICS = {
	        childContextTypes: true,
	        contextTypes: true,
	        defaultProps: true,
	        displayName: true,
	        getDefaultProps: true,
	        getDerivedStateFromProps: true,
	        mixins: true,
	        propTypes: true,
	        type: true
	    };
	    
	    var KNOWN_STATICS = {
	        name: true,
	        length: true,
	        prototype: true,
	        caller: true,
	        callee: true,
	        arguments: true,
	        arity: true
	    };
	    
	    var defineProperty = Object.defineProperty;
	    var getOwnPropertyNames = Object.getOwnPropertyNames;
	    var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	    var getPrototypeOf = Object.getPrototypeOf;
	    var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	    
	    return function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	        if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	            
	            if (objectPrototype) {
	                var inheritedComponent = getPrototypeOf(sourceComponent);
	                if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                    hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	                }
	            }
	            
	            var keys = getOwnPropertyNames(sourceComponent);
	            
	            if (getOwnPropertySymbols) {
	                keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	            }
	            
	            for (var i = 0; i < keys.length; ++i) {
	                var key = keys[i];
	                if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                    var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                    try { // Avoid failures from read-only properties
	                        defineProperty(targetComponent, key, descriptor);
	                    } catch (e) {}
	                }
	            }
	            
	            return targetComponent;
	        }
	        
	        return targetComponent;
	    };
	})));


/***/ }),

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(99);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-medium' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title has-text-centered' },
	            'HOW IT WORKS'
	          ),
	          _react2.default.createElement(
	            'nav',
	            { className: 'level' },
	            _react2.default.createElement(
	              'div',
	              { className: 'level-item has-text-centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap-text' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'big-number' },
	                  '1.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-bold header is-size-4 has-vert-space' },
	                  'Claim Your Unit'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'has-bottom-margin' },
	                  'Follow the sign-up process in our app to get your home ready for short-term rentals.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'level-item has-text-centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap-text' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'big-number' },
	                  '2.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-bold has-vert-space header is-size-4' },
	                  'Open Your Calendar'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'has-bottom-margin' },
	                  'Going away? Unblock dates within the app to activate your property on booking platforms.'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'level-item has-text-centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap-text' },
	                _react2.default.createElement(
	                  'h1',
	                  { className: 'big-number' },
	                  '3.'
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-bold has-vert-space header is-size-4' },
	                  'Sit Back & Relax'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'has-bottom-margin' },
	                  'Let us take care of everything with our fully managed solution, while you enjoy your time away.'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-fullheight has-bg-img-2' },
	      _react2.default.createElement('div', { className: 'yellow-block flip-horizontal' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container has-text-right' },
	          _react2.default.createElement(
	            'h1',
	            { className: 'title is-spaced' },
	            'HOW MUCH COULD YOU EARN?'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'subtitle' },
	            'One Bedroom \xA368 - \xA392/night'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'subtitle' },
	            'Two Bedroom \xA385 - \xA3115/night'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'subtitle' },
	            'Three Bedroom \xA3111 - \xA3150/night'
	          ),
	          _react2.default.createElement(
	            'a',
	            { href: 'https://home.lavanda.app/onboarding/signup/oneeighty', className: 'button is-large' },
	            'Claim Your Unit'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-medium is-primary' },
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'nav',
	            { className: 'level' },
	            _react2.default.createElement(
	              'div',
	              { className: 'level-item has-text-centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap-text' },
	                _react2.default.createElement(
	                  'svg',
	                  {
	                    xmlns: 'http://www.w3.org/2000/svg',
	                    width: '48',
	                    height: '48',
	                    viewBox: '0 0 48 48'
	                  },
	                  _react2.default.createElement(
	                    'g',
	                    {
	                      'class': 'nc-icon-wrapper',
	                      'stroke-linecap': 'round',
	                      'stroke-linejoin': 'round',
	                      'stroke-width': '1',
	                      transform: 'translate(0.5 0.5)',
	                      fill: '#ffffff',
	                      stroke: '#ffffff'
	                    },
	                    _react2.default.createElement('path', {
	                      d: 'M22.3,9a7,7,0,1,0,0,6H28l3,2,3-2h5l1-6Z',
	                      fill: 'none',
	                      'stroke-miterlimit': '10',
	                      'data-color': 'color-2'
	                    }),
	                    _react2.default.createElement('path', {
	                      d: 'M9,26h2a9.583,9.583,0,0,1,8,4h6a6.621,6.621,0,0,1,6,6H17',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      'data-cap': 'butt'
	                    }),
	                    _react2.default.createElement('path', {
	                      d: 'M29.2,32H39a6.074,6.074,0,0,1,6,4L23.8,43.7a9.45,9.45,0,0,1-5-.2L9,38.9',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      'data-cap': 'butt'
	                    }),
	                    _react2.default.createElement('rect', {
	                      x: '3',
	                      y: '24',
	                      width: '6',
	                      height: '16',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10'
	                    }),
	                    _react2.default.createElement('circle', {
	                      cx: '15',
	                      cy: '12',
	                      r: '2',
	                      'data-cap': 'butt',
	                      'data-color': 'color-2',
	                      'data-stroke': 'none',
	                      stroke: 'none'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-bold header is-size-4 has-vert-space' },
	                  'Hassle-Free Hosting'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'has-bottom-margin' },
	                  'Our fully managed short-term rental solution allows you to host guests, 100% hassle free!'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'level-item has-text-centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap-text' },
	                _react2.default.createElement(
	                  'svg',
	                  {
	                    xmlns: 'http://www.w3.org/2000/svg',
	                    width: '48',
	                    height: '48',
	                    viewBox: '0 0 48 48'
	                  },
	                  _react2.default.createElement(
	                    'g',
	                    {
	                      'class': 'nc-icon-wrapper',
	                      'stroke-linecap': 'round',
	                      'stroke-linejoin': 'round',
	                      'stroke-width': '1',
	                      transform: 'translate(0.5 0.5)',
	                      fill: '#ffffff',
	                      stroke: '#ffffff'
	                    },
	                    _react2.default.createElement('path', {
	                      'data-cap': 'butt',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      d: 'M8,26h3c3.284,0,6.3,1.462,8,4h6 c2.907,0,6,3.093,6,6H17'
	                    }),
	                    ' ',
	                    _react2.default.createElement('path', {
	                      'data-cap': 'butt',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      d: 'M29.176,32H39c4.833,0,6,4,6,4 l-21.203,7.746c-1.647,0.392-3.37,0.33-4.985-0.18L8,39'
	                    }),
	                    ' ',
	                    _react2.default.createElement('circle', {
	                      'data-color': 'color-2',
	                      fill: 'none',
	                      'stroke-miterlimit': '10',
	                      cx: '33',
	                      cy: '19',
	                      r: '5'
	                    }),
	                    ' ',
	                    _react2.default.createElement('circle', {
	                      'data-color': 'color-2',
	                      fill: 'none',
	                      'stroke-miterlimit': '10',
	                      cx: '19',
	                      cy: '9',
	                      r: '5'
	                    }),
	                    ' ',
	                    _react2.default.createElement('rect', {
	                      x: '2',
	                      y: '24',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      width: '6',
	                      height: '16'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-bold has-vert-space header is-size-4' },
	                  'Lower Your Cost Of Living'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'has-bottom-margin' },
	                  'Use short-term rentals as a way to earn some extra money to help pay for your time away!'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'level-item has-text-centered' },
	              _react2.default.createElement(
	                'div',
	                { className: 'wrap-text' },
	                _react2.default.createElement(
	                  'svg',
	                  {
	                    xmlns: 'http://www.w3.org/2000/svg',
	                    width: '48',
	                    height: '48',
	                    viewBox: '0 0 48 48'
	                  },
	                  _react2.default.createElement(
	                    'g',
	                    {
	                      'class': 'nc-icon-wrapper',
	                      'stroke-linecap': 'round',
	                      'stroke-linejoin': 'round',
	                      'stroke-width': '1',
	                      transform: 'translate(0.5 0.5)',
	                      fill: '#ffffff',
	                      stroke: '#ffffff'
	                    },
	                    _react2.default.createElement('polyline', {
	                      'data-cap': 'butt',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      points: '34,11 22,3 10,11 '
	                    }),
	                    ' ',
	                    _react2.default.createElement('polyline', {
	                      'data-cap': 'butt',
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      points: '27,39 2,39 2,11 42,11 42,20.071 '
	                    }),
	                    ' ',
	                    _react2.default.createElement('line', {
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      x1: '10',
	                      y1: '21',
	                      x2: '24',
	                      y2: '21'
	                    }),
	                    ' ',
	                    _react2.default.createElement('line', {
	                      fill: 'none',
	                      stroke: '#ffffff',
	                      'stroke-miterlimit': '10',
	                      x1: '10',
	                      y1: '29',
	                      x2: '18',
	                      y2: '29'
	                    }),
	                    ' ',
	                    _react2.default.createElement('polyline', {
	                      'data-cap': 'butt',
	                      'data-color': 'color-2',
	                      fill: 'none',
	                      'stroke-miterlimit': '10',
	                      points: '44,32.292 44,45 38,42 32,45 32,32.292 '
	                    }),
	                    ' ',
	                    _react2.default.createElement('circle', {
	                      'data-color': 'color-2',
	                      fill: 'none',
	                      'stroke-miterlimit': '10',
	                      cx: '38',
	                      cy: '27',
	                      r: '8'
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  'h2',
	                  { className: 'has-text-weight-bold has-vert-space header is-size-4' },
	                  'Approved Partner'
	                ),
	                _react2.default.createElement(
	                  'p',
	                  { className: 'has-bottom-margin' },
	                  'One Eighty short-term rentals has been fully approved and enabled by your building management!'
	                )
	              )
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'section',
	      { className: 'hero is-fullheight has-bg-img-3' },
	      _react2.default.createElement('div', { className: 'yellow-block' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-body' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'diamond-container' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'title is-1 is-spaced' },
	              'YOUR SHORT TERM RENTAL SERVICE'
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'subtitle is-4 is-spaced' },
	              'Earn extra income from your home while you are away with One Eighty\u2019s brand new short-term rental service.'
	            ),
	            _react2.default.createElement(
	              'a',
	              { href: 'https://home.lavanda.app/onboarding/signup/oneeighty', className: 'button is-large' },
	              'Get Started Today'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-a25bc0edaa4d073e1909.js